/**
 * Formata uma string de data no formato "YYYY-MM-DD" para o formato "DD/MM/YYYY"
 * @param {*} dataString - String de data no formato ISO 8601
 * @returns Data formatada no formato "DD/MM/YYYY"
 */
export default function formatDates(dataString) {
  if (!dataString) return "";

  try {
    if (dataString.includes("/")) return dataString;

    // --- CORREÇÃO DO BUG DE FUSO HORÁRIO SEM QUEBRAR O RESTO ---
    // Se a string tiver exatamente o formato YYYY-MM-DD (sem o "T" de hora)
    if (typeof dataString === "string" && dataString.length === 10 && dataString.includes("-")) {
      const [ano, mes, dia] = dataString.split("-");
      return `${dia}/${mes}/${ano}`;
    }
    if (dataString.includes("/")) return dataString;

    const data = new Date(dataString);
    const dataAtual = new Date(data.getTime());

    const dia = String(dataAtual.getDate()).padStart(2, "0");
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const ano = dataAtual.getFullYear();

    return `${dia}/${mes}/${ano}`;
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return dataString;
  }
}

/**
 * Formata uma string de data no formato "YYYY-MM-DDTHH:mm:ss.sssZ"
 * para o formato "DD/MM/YYYY - HH:mm:ss", ajustando para o horário de Brasília (UTC-3)
 * @param {*} dataString - String de data no formato ISO 8601
 * @returns Data formatada no formato "DD/MM/YYYY - HH:mm:ss"
 */
export function formatDatesHoras(dataString) {
  if (!dataString) return "";

  try {
    if (dataString.includes("/")) return dataString;

    const data = new Date(dataString);
    const dataAtual = new Date(data.getTime());

    const dia = String(dataAtual.getDate()).padStart(2, "0");
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
    const ano = dataAtual.getFullYear();

    const hora = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    return `${dia}/${mes}/${ano} - ${hora}:${minutos}:${segundos}`;
  } catch (error) {
    console.error("Erro ao formatar data e hora:", error);
    return dataString;
  }
}
